import { useCallback } from 'react';
import {
  useQuery,
  useSuspenseQuery,
  QueryResult,
  useLazyQuery,
  useApolloClient,
  QueryOptions,
  QueryHookOptions,
  SuspenseQueryHookOptions,
  LazyQueryHookOptions,
  LazyQueryExecFunction
} from '@apollo/client';
import { useSnackbarHelper } from '../../useSnackbarHelper';
import QUERY from '../operations/InfluencerYoutubeCompareTagRanking.graphql';
import { Query, QueryinfluencerYoutubeCompareTagRankingArgs } from '../../__generated__/globalTypes';

export const useInfluencerYoutubeCompareTagRankingQuery = (
  options?: QueryHookOptions<Query, QueryinfluencerYoutubeCompareTagRankingArgs>
) => {
  const { t, enqueueSnackbar } = useSnackbarHelper();
  const result = useQuery<Query, QueryinfluencerYoutubeCompareTagRankingArgs>(QUERY, {
    onError: (error) => {
      enqueueSnackbar(t(error.message), { variant: 'error' });
    },
    ...options
  });

  return result;
};

export const useInfluencerYoutubeCompareTagRankingLazyQuery = (
  options?: LazyQueryHookOptions<Query, QueryinfluencerYoutubeCompareTagRankingArgs>
): QueryResult<Query, QueryinfluencerYoutubeCompareTagRankingArgs> & {
  getInfluencerYoutubeCompareTagRanking: LazyQueryExecFunction<Query, QueryinfluencerYoutubeCompareTagRankingArgs>;
} => {
  const { t, enqueueSnackbar } = useSnackbarHelper();
  const [getInfluencerYoutubeCompareTagRanking, result] = useLazyQuery<
    Query,
    QueryinfluencerYoutubeCompareTagRankingArgs
  >(QUERY, {
    onError: (error) => {
      enqueueSnackbar(t(error.message), { variant: 'error' });
    },
    ...options
  });

  return { getInfluencerYoutubeCompareTagRanking, ...result };
};

export const useInfluencerYoutubeCompareTagRankingPromiseQuery = () => {
  const client = useApolloClient();

  const getInfluencerYoutubeCompareTagRanking = useCallback(
    (options?: Omit<QueryOptions<QueryinfluencerYoutubeCompareTagRankingArgs, Query>, 'query'>) =>
      client.query<Query, QueryinfluencerYoutubeCompareTagRankingArgs>({ ...options, query: QUERY }),
    [client]
  );

  return { getInfluencerYoutubeCompareTagRanking };
};
// Suspense Query Hooks
export const useInfluencerYoutubeCompareTagRankingSuspenseQuery = (
  options?: SuspenseQueryHookOptions<Query, QueryinfluencerYoutubeCompareTagRankingArgs>
) => {
  const result = useSuspenseQuery<Query, QueryinfluencerYoutubeCompareTagRankingArgs>(QUERY, {
    ...options
  });

  return result;
};
